import {Component, Input} from "@angular/core";
import {FilteredList} from "../helpers/filtered-list";

@Component({
  selector: "filtered-list-filters",
  templateUrl: "./filtered-list-filters.template.pug",
})
export class FilteredListFiltersComponent {
  @Input()
  list: FilteredList<any> = new FilteredList();
}
